import { Box, Container } from '@chakra-ui/react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import React, { FC, ReactNode } from 'react';
import Bottombar from 'src/components/common/bottombar/Bottombar';
import Topbar from 'src/components/common/topbar/Topbar';
import { User } from 'src/models';

type Props = {
    backgroundImage?: string;
    multiUser?: boolean;
    isReady?: boolean;
    backUrl?: string;
    onBackClick?: () => void;
    topbarActionComponent?: ReactNode;
    bottombar?: boolean;
    bottombarActionComponent?: ReactNode;
    title?: string;
    children: ReactNode;
    innerPaddingTop?: number;
    innerPaddingBottom?: number;
    containerHeight?: string;
    paddingX?: number;
    currentUser?: User;
    users?: User[];
    setCurrentUserId?: (users: User[], userId?: string | undefined) => void;
    showUserPicker?: boolean;
};

const Layout: FC<Props> = (props) => {
    const {
        backgroundImage,
        multiUser,
        isReady = true,
        backUrl,
        onBackClick,
        topbarActionComponent,
        bottombar = true,
        bottombarActionComponent,
        title,
        children,
        innerPaddingTop = 36,
        innerPaddingBottom = 20,
        containerHeight,
        paddingX,
        currentUser,
        users,
        setCurrentUserId,
        showUserPicker
    } = props;
    const { t } = useTranslation('index');

    return (
        <>
            <Head>
                <title>BackResto</title>
                <meta content={t('meta-description')} name="description" />
                <link href="/favicon.ico" rel="icon" sizes="any" />
                <link href="/icons/icon-48x48.png" rel="icon" sizes="48x48" type="image/png" />
                <link href="/icons/icon-192x192.png" rel="icon" sizes="192x192" type="image/png" />

                <meta content="BackResto" name="application-name" />
                <meta content="yes" name="apple-mobile-web-app-capable" />
                <meta content="default" name="apple-mobile-web-app-status-bar-style" />
                <meta content="BackResto" name="apple-mobile-web-app-title" />
                <meta content={t('meta-description')} name="description" />
                <meta content="telephone=no" name="format-detection" />
                <meta content="yes" name="mobile-web-app-capable" />
                <meta content="#FFFFFF" name="theme-color" />
                <link href="/icons/icon-192x192.png" rel="apple-touch-icon" />
            </Head>
            <span />
            {title && (
                <Topbar
                    actionComponent={topbarActionComponent}
                    backUrl={backUrl}
                    currentUser={currentUser}
                    isReady={isReady}
                    multiUser={multiUser}
                    setCurrentUserId={setCurrentUserId}
                    showUserPicker={showUserPicker}
                    title={title}
                    users={users}
                    onBackClick={onBackClick}
                />
            )}
            <Box backgroundImage={backgroundImage} backgroundRepeat="repeat-x">
                <Container
                    height={containerHeight}
                    id="container"
                    maxW="container.sm"
                    overflow="scroll"
                    paddingBottom={bottombar ? innerPaddingBottom : 0}
                    paddingTop={title ? innerPaddingTop : 0}
                    paddingX={paddingX}>
                    {children}
                </Container>
            </Box>
            {bottombar && <Bottombar actionComponent={bottombarActionComponent} />}
        </>
    );
};

export default Layout;
